/** @jsx h */
import { h } from "hyperapp";
import classNames from "classnames";
import Track from "./track";

export default function Recommended({
  items,
  currentItemPlayerItemID,
  visible
}) {
  return (
    <ul
      class={classNames("player-recommended-list", {
        "player-recommended-list--hidden": !visible
      })}
    >
      {items.map(item => {
        const isCurrentItem = currentItemPlayerItemID === item.player_item.id;
        return <Track item={item} isCurrentItem={isCurrentItem} />;
      })}
    </ul>
  );
}
